import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-20 pb-16">
      {/* Hero Section */}
      <div className="gradient-primary text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-primary-900 opacity-10 pattern-grid"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">מדיניות פרטיות</h1>
            <p className="text-xl text-primary-100">
              המידע שלך חשוב לנו - כאן תוכל למצוא את כל הפרטים על האופן שבו אנו מגנים עליו
            </p>
          </div>
        </div>
      </div>

      {/* תוכן מדיניות הפרטיות */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold mb-6">שימוש בקבצי Cookie</h2>
              <p className="mb-6">
                האתר שלנו משתמש בקבצי Cookie כדי לשפר את חווית המשתמש שלך. קבצי Cookie הם קבצי טקסט קטנים
                המאוחסנים על המכשיר שלך כאשר אתה מבקר באתר שלנו.
              </p>

              <h3 className="text-xl font-semibold mb-4">סוגי קבצי Cookie שאנו משתמשים בהם:</h3>
              <ul className="list-disc mr-6 mb-6 space-y-2">
                <li>
                  <strong>קבצי Cookie הכרחיים:</strong> נדרשים לפעולה תקינה של האתר ולא ניתן לכבות אותם.
                </li>
                <li>
                  <strong>קבצי Cookie אנליטיים:</strong> עוזרים לנו להבין כיצד המבקרים משתמשים באתר.
                </li>
                <li>
                  <strong>קבצי Cookie פונקציונליים:</strong> מאפשרים פונקציות מתקדמות וגישה מותאמת אישית.
                </li>
              </ul>

              <h2 className="text-2xl font-bold mb-6">איסוף מידע</h2>
              <p className="mb-6">
                אנו אוספים מידע באופן אוטומטי כאשר אתה מבקר באתר שלנו, כולל:
              </p>
              <ul className="list-disc mr-6 mb-6 space-y-2">
                <li>כתובת IP</li>
                <li>סוג הדפדפן</li>
                <li>העדפות שפה</li>
                <li>זמני כניסה ויציאה</li>
                <li>דפים שבהם ביקרת</li>
              </ul>

              <h2 className="text-2xl font-bold mb-6">שימוש במידע</h2>
              <p className="mb-6">
                המידע שאנו אוספים משמש אותנו ל:
              </p>
              <ul className="list-disc mr-6 mb-6 space-y-2">
                <li>שיפור השירותים שלנו</li>
                <li>התאמה אישית של חווית המשתמש</li>
                <li>ניתוח וסטטיסטיקות</li>
                <li>אבטחת האתר</li>
              </ul>

              <h2 className="text-2xl font-bold mb-6">אבטחת מידע</h2>
              <p className="mb-6">
                אנו נוקטים באמצעי אבטחה מתקדמים כדי להגן על המידע שלך מפני גישה, שימוש או חשיפה בלתי מורשים.
              </p>

              <h2 className="text-2xl font-bold mb-6">זכויותיך</h2>
              <p className="mb-6">
                יש לך זכות לבקש גישה למידע האישי שלך, לתקן אותו, למחוק אותו או להגביל את השימוש בו.
                ניתן לפנות אלינו בכל שאלה או בקשה בנושא.
              </p>

              <h2 className="text-2xl font-bold mb-6">יצירת קשר</h2>
              <p className="mb-6">
                לכל שאלה בנושא מדיניות הפרטיות, ניתן ליצור איתנו קשר:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="mb-2">טלפון: 050-973-9003</p>
                <p className="mb-2">אימייל: info@dit.co.il</p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <Link 
                to="/"
                className="inline-block bg-primary-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-primary-700 transition-colors"
              >
                חזרה לדף הבית
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 